module.exports = __webpack_public_path__ + "static/media/pink-october.bbd6985a.png";